import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  /**
   * 'default' — compact no-data state (md title).
   * 'hero' — full-screen welcome greeting; matches the Chat/Summary greeting scale
   * (2xl title + md description) so text sizes stay consistent across the tools. (#78764)
   */
  variant?: 'default' | 'hero';
}

/** DS empty state — centered icon + title + text (design-guidelines.md §4). */
export const EmptyState = ({
  icon,
  title,
  description,
  action,
  variant = 'default',
}: EmptyStateProps) => {
  const isHero = variant === 'hero';
  return (
    <Flex align='center' direction='column' gap={3} px={6} py={12} textAlign='center'>
      {icon && (
        <Flex
          align='center'
          justify='center'
          w='56px'
          h='56px'
          color='primary.solid'
          bg='primary.soft'
          borderRadius='lg'
        >
          {icon}
        </Flex>
      )}
      <Text
        color='text.default'
        fontFamily='heading'
        fontSize={isHero ? '2xl' : 'md'}
        fontWeight={600}
        letterSpacing={isHero ? '-0.02em' : undefined}
      >
        {title}
      </Text>
      {description && (
        <Text maxW='360px' color='text.muted' fontSize={isHero ? 'base' : 'sm'}>
          {description}
        </Text>
      )}
      {action && <Box mt={2}>{action}</Box>}
    </Flex>
  );
};

export default EmptyState;
